<div>
  <div mat-dialog-title>
    <div class="d-flex justify-content-between">
      <p>Copy Transmittal template</p> 
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
  </div> 
  <div mat-dialog-content [formGroup]="transmittalForm">
    <div class="row eip-form-controls m-0 eip-mt-15">    
      <div  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6" >       
       <mat-form-field>
         <mat-label>Enter new Transmittal Name *</mat-label>
         <input  matInput formControlName="TemplateNewName">
      </mat-form-field> 
      <mat-error *ngIf="transmittalForm.get('TemplateNewName').touched && transmittalForm.get('TemplateNewName').hasError('required')">
        TemplateNewName is required 
      </mat-error>     
      </div>     
     </div>
    <div mat-dialog-actions>
      <div class="row justify-content-end flex-grow-1">
        <button   class="btn btn-primary" (click)="postData()">Save</button>
      </div> 
    </div>
  </div>
</div>
